<template>
  <div>
    <q-item
      v-if="items.length === 1 && items[0] === '_OLG_'"
      tag="label"
      :dense="dense"
    >
      <q-item-section>
        <q-item-label>{{ label }}</q-item-label>
        <q-item-label caption
          >Please login or register for an account.</q-item-label
        >
      </q-item-section>
      <q-item-section side>
        <q-icon name="lock"></q-icon>
      </q-item-section>
    </q-item>
    <q-select
      v-else
      :label="label"
      :options="filterInputOptions"
      :value="filterInput"
      :dense="dense"
      :options-dense="dense"
      outlined
      clearable
      input-debounce="0"
      multiple
      use-chips
      use-input
      @filter="filterFn"
      @input="filterInputFn"
    ></q-select>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dedupe } from "@/utils";

export default {
  name: "AutocompleteChild",
  props: {
    id: {
      required: true,
      type: String,
      default: "",
    },
    label: {
      required: true,
      type: String,
      default: "",
    },
    items: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    parentId: {
      required: true,
      type: String,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Array,
    },
  },
  data() {
    return {
      filterInput: [],
      filterInputOptions: [],
    };
  },
  computed: {
    ...mapGetters(["filteredCourses"]),
    itemsFiltered() {
      const { id, filteredCourses, items } = this;

      if (!filteredCourses.length) {
        return items;
      }

      const allItems = filteredCourses.map(course => course[id]);
      const deDupedItems = dedupe(allItems);

      return deDupedItems.sort();
    },
  },
  mounted() {
    this.$root.$on("reset-filter-input", () => {
      console.debug("reset-filter-input in autocomplete");

      this.reset();
    });
  },
  beforeDestroy() {
    this.$root.$off("reset-filter-input");
  },
  methods: {
    reset() {
      if (this.filterInput.length) {
        this.filterInput = [];
      }
    },
    filterFn(val, update) {
      update(() => {
        const items = this.itemsFiltered;
        const needle = val.toLowerCase();

        this.filterInputOptions = items.filter(
          item => item.toLowerCase().indexOf(needle) > -1,
        );
      });
    },
    filterInputFn(val) {
      return (this.filterInput = val === null ? [] : val);
    },
  },
  watch: {
    filterInput(newVal) {
      this.$emit("update", this.id, newVal);
    },
    filter: {
      handler: function(newVal) {
        if (newVal && newVal.length && !this.filterInput.length) {
          this.filterInput = newVal;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped></style>
